import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ShouldConvertStatusCodeErrors } from '../../typings/property-force-api';
import { MiddlewareMessageService } from '../services/middleware-message.service';

@Injectable({
  providedIn: 'root'
})
export class StatusCodeInterceptor implements HttpInterceptor {
  private middlewareMessageService = inject(MiddlewareMessageService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    let handledRequest: Observable<HttpEvent<unknown>>;

    if (request.context.get(ShouldConvertStatusCodeErrors)) {
      handledRequest = next.handle(request).pipe(
        switchMap((event) => {
          const handledEvent = of(event);
          if (event instanceof HttpResponse) {
            const { error, hasError, isInvalidKey } = this.middlewareMessageService.processStatus(
              event.body?.d?.StatusCode,
              event.body?.d?.Status
            );
            if (!isInvalidKey && hasError) {
              return throwError(() => error);
            }
          }
          return handledEvent;
        })
      );
    } else {
      handledRequest = next.handle(request);
    }
    return handledRequest;
  }
}
